<template>
  <div
    v-for="({ id, variant = 'primary', label, oldValue, value, tooltip, eSpot, customClass }) in items"
    :key="`order-summary-${id}`"
    :data-test-id="`order-summary-${id}`"
    style="--dash-color: #9a9a9a"
  >
    <!-- espot -->
    <slot v-if="eSpot && $slots[eSpot]" :name="eSpot" />
    <div class="flex between" :class="[rowBrandClasses[variant], customClass?.row]">
      <div class="w-3/5 md:w-4/5" :class="customClass?.label">
        <cart-promo-toggletip
          v-if="tooltip"
          :data-test-id="`${id}-tooltip`"
          :details="tooltip"
          :text="label"
        />
        <span v-else>{{ label }}</span>
      </div>
      <p v-if="value" class="ws-nowrap break-keep fw-bold" :class="[rowValue, customClass?.value]">
        <span v-if="oldValue" class="mr-2 line-through">{{ oldValue }}</span>
        <span>{{ value }}</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { OrderSummaryItem } from '#types/components/vf/orderSummary'

defineProps<{
  /**
   * Array of summary row objects
   */
  items: OrderSummaryItem[]
}>()
const {
  brandClasses: { row: rowBrandClasses = {}, rowValue } = {}
} = useAppConfig().components.order.summary
</script>
